import React, { useEffect, useContext } from "react";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import useReviews from "../reviews/useReviews";
import { VariantContextData } from "../variants/VariantBuilderContext";
import { convertIconToSvg } from "../../utils/builderUtils";

const ElementSettingsReviewsContent = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const { Reviews } = useReviews();

  let element = props.element;

  useEffect(() => {
    // Make sure the list is ordered by position when the page loads
    let wrapper = $("#options-panel .sortable-container.reviews-content");
    wrapper
      .find(".setting[data-setting_type='item_v2'][data-draggable='true']")
      .sort(function (a, b) {
        return (
          +a.getAttribute("data-position") - +b.getAttribute("data-position")
        );
      })
      .appendTo(wrapper);

    Reviews.sortableContentStart(element);
  }, [element]);

  const reviewRatingSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-rating-settings-${element.id}`}
        object={element}
        setting_name="[rating-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Star Rating"
        label_icon={"fa-star"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["rating-position"]}
        hide_edit={true}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][rating-show]"
        toggle_value={element.options["rating-show"] ? element.options["rating-show"] : toggleValue}
      >
      </VariantBuilderSetting>
    );
  }

  const reviewTitleSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-title-settings-${element.id}`}
        object={element}
        setting_name="[title-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Review Title"
        label_icon={"fa-quote-left"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["title-position"]}
        hide_edit={true}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][title-show]"
        toggle_value={element.options["title-show"] ? element.options["title-show"] : toggleValue}
      >
      </VariantBuilderSetting>
    );
  }

  const reviewContentSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-content-settings-${element.id}`}
        object={element}
        setting_name="[content-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Content"
        label_icon={"fa-quote-left"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["content-position"]}
        hide_edit={true}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][content-show]"
        toggle_value={element.options["content-show"] ? element.options["content-show"] : toggleValue}
      >
      </VariantBuilderSetting>
    );
  }

  const reviewCustomerProfileSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-customer-profile-settings-${element.id}`}
        object={element}
        setting_name="[customer-profile-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Customer Profile"
        label_icon={"fa-user"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["customer-profile-position"]}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][customer-profile-show]"
        toggle_value={element.options["customer-profile-show"] ? element.options["customer-profile-show"] : toggleValue}
      >
        <VariantBuilderSetting
          object={element}
          setting_name="[options][customer-profile-show-avatar]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["customer-profile-show-avatar"]
              ? element.options["customer-profile-show-avatar"]
              : "true"
          }
          label="Show Avatar"
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][customer-profile-show-name]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["customer-profile-show-name"]
              ? element.options["customer-profile-show-name"]
              : "true"
          }
          label="Show Name"
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][customer-profile-show-title]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["customer-profile-show-title"]
              ? element.options["customer-profile-show-title"]
              : "true"
          }
          label="Show Title"
        />
      </VariantBuilderSetting>
    );
  }

  const reviewBrandLogoSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-brand-logo-settings-${element.id}`}
        object={element}
        setting_name="[brand-logo-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Brand Logo"
        label_icon={"fa-image"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["brand-logo-position"]}
        hide_edit={true}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][brand-logo-show]"
        toggle_value={element.options["brand-logo-show"] ? element.options["brand-logo-show"] : toggleValue}
      >
      </VariantBuilderSetting>
    );
  }

  const reviewVideoSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-video-settings-${element.id}`}
        object={element}
        setting_name="[video-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Video"
        label_icon={"fa-video"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["video-position"]}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][video-show]"
        toggle_value={element.options["video-show"] ? element.options["video-show"] : toggleValue}
      >
        <VariantBuilderSetting
          object={element}
          setting_name="[options][video-positioning]"
          setting_type="select"
          label="Video Position"
          object_type="elements"
          object_id={element.id}
          value={element.options["video-positioning"]}
          placeholder={"background"}
          options={[
            { value: "background", label: "Background" },
            { value: "left", label: "Left" },
            { value: "right", label: "Right" },
            { value: "inline", label: "In Content" }
          ]}
          col="12"
        />
      </VariantBuilderSetting>
    );
  }

  const reviewDateSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-date-settings-${element.id}`}
        object={element}
        setting_name="[date-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Date"
        label_icon={"fa-calendar"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["date-position"]}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][date-show]"
        toggle_value={element.options["date-show"] ? element.options["date-show"] : toggleValue}
      >
        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Date Format"
          setting_name={`[options][date-format]`}
          setting_type="dropdown"
          value={element.options[`date-format`]}
          placeholder="YYYY-MM-DD"
          options={[
            { value: "YYYY/MM/DD", text: "2024/06/27 (YYYY/MM/DD)" },
            { value: "MM/DD/YYYY", text: "06/27/2024 (MM/DD/YYYY)" },
            { value: "DD/MM/YYYY", text: "27/06/2024 (DD/MM/YYYY)" },
            { value: "MMMM DD, YYYY", text: "June 27, 2024 (MMMM DD, YYYY)" },
            { value: "DD MMMM YYYY", text: "27 June 2024 (DD MMMM YYYY)" },
          ]}
        />
      </VariantBuilderSetting>
    );
  }

  const reviewSourceSettings = (toggleValue) => {
    return (
      <VariantBuilderSetting
        key={`review-source-settings-${element.id}`}
        object={element}
        setting_name="[source-position]"
        setting_type="item_v2"
        object_type="elements"
        object_id={element.id}
        title="Source"
        label_icon={"fa-location-dot"}
        label_max_length={40}
        label_hover_max_length={30}
        style={{ margin: "4px 0px" }}
        position={element.options["source-position"]}
        hide_duplicate={true}
        hide_remove={true}
        toggle_setting_name="[options][source-show]"
        toggle_value={element.options["source-show"] ? element.options["source-show"] : toggleValue}
      >

        <VariantBuilderSetting
          object={element}
          setting_name="[options][source]"
          setting_type="editor"
          object_type="elements"
          object_id={element.id}
          label="Source"
          value={element.options["source"]}
          placeholder="Source"
          allow_empty={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][source-link]"
          setting_type="text"
          object_type="elements"
          object_id={element.id}
          label="Source Link"
          value={element.options["source-link"]}
          placeholder="https://trustpilot.com"
          allow_empty={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][source-show-icon]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["source-show-icon"]
              ? element.options["source-show-icon"]
              : "false"
          }
          label="Show Icon"
        />

        <VariantBuilderSetting
          object={element}
          object_type="elements"
          object_id={element.id}
          label="Source Icon"
          setting_name={`[options][source-icon]`}
          setting_type="icon"
          value={element.options[`source-icon`] ? element.options[`source-icon`] : "fas fa-check-circle"}
          placeholder=""
          condition={
            element.options["source-show-icon"] == "true"
          }
          callback={(value) => {
            const svgString = convertIconToSvg(value);
            if (svgString) {
              builder.update([
                {
                  object_type: 'elements',
                  object_id: element.id,
                  setting_name: '[options][source-icon-svg]',
                  value: svgString,
                  skip_history: true,
                }
              ]);
            }
          }}
        />
      </VariantBuilderSetting>
    );
  }

  return (
    <React.Fragment>
      <div
        className="col-xs-12 sortable-container reviews-content"
        data-object_type="elements"
        data-object_id={element.id}
      >
        {Object.keys(ReviewService.availableSettingTypes(element)).map((type) => {
          const methodName = `review${ReviewService.constantizeString(type)}Settings`;
          return eval(methodName)(ReviewService.availableSettingTypes(element)[type]);
        })}
      </div>
    </React.Fragment>
  );
};

export default ElementSettingsReviewsContent;
